<script setup lang="ts">
import { Banknote, Smartphone } from 'lucide-vue-next'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

const documentStore = useDocumentStore()
function openDetails() {
  documentStore.openDocument('rekvizity-mkk-nebus.pdf', 'Реквизиты МКК Небус')
}
const route = useRoute()
const scrollOffset = 100

const currentTab = ref('lk')
onMounted(() => {
  if (route.query.details) {
    currentTab.value = 'bank'

    nextTick(() => {
      setTimeout(() => {
        const element = document.getElementById('howpay')
        if (element) {
          const elementTop = element.getBoundingClientRect().top + window.scrollY
          const offsetPosition = elementTop - scrollOffset

          window.scrollTo({
            top: offsetPosition,
          })
        }
      }, 0)
    })
  }
})
</script>

<template>
  <section id="howpay" class="py-16">
    <div class="container mx-auto px-4">
      <div class="text-center mb-6">
        <h2 class="text-3xl font-bold text-title mb-2">
          Как платить по займу
        </h2>
        <p class="text-gray-600">
          Выберите удобный способ оплаты
        </p>
      </div>

      <Tabs v-model="currentTab" default-value="lk" class="w-full">
        <TabsList class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-6 md:mb-8 max-w-md mx-auto">
          <TabsTrigger value="lk" class="py-3 hover:bg-slate-100 rounded-lg data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
            Личный кабинет
          </TabsTrigger>
          <TabsTrigger value="bank" class="py-3 hover:bg-slate-100 rounded-lg data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
            Банковский перевод
          </TabsTrigger>
        </TabsList>

        <TabsContent value="lk" class="bg-white rounded-xl p-6 border">
          <div class="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            <div class="flex-1 space-y-4 flex flex-col items-center justify-center">
              <h3 class="text-xl md:text-2xl font-semibold text-title">
                Оплата через личный кабинет
              </h3>
              <p class="text-gray-600">
                Просто перейдите в <a
                  href="https://login.nebusfinance.ru/login"
                  class="text-primary hover:underline font-medium"
                >
                  личный кабинет

                </a> и оплатите очередной платеж банковской картой
              </p>
              <div class="flex gap-4 justify-center md:justify-start">
                <NuxtImg src="/img/logo_visa.svg" alt="Visa" class="h-8" />
                <NuxtImg src="/img/logo_mc.svg" alt="Mastercard" class="h-8" />
                <NuxtImg src="/img/logo_mir.svg" alt="МИР" class="h-8" />
              </div>
            </div>
            <!-- <div class="hidden md:block flex-1 max-w-xs">
              <img
                src="/assets/lk-preview.png"
                alt="Личный кабинет"
                class="rounded-lg shadow-sm border"
              >
            </div> -->
          </div>
        </TabsContent>

        <TabsContent value="bank" class="bg-white rounded-xl p-6 md:p-8 border">
          <div class="text-center space-y-4">
            <h3 class="text-xl md:text-2xl font-semibold text-title">
              Банковский перевод
            </h3>
            <div class="text-gray-600 space-y-2">
              <p>
                Оплатить заем можно в любом банке России или через Почту России банковским переводом на наш счет по <button class="text-primary hover:underline" @click="openDetails">
                  реквизитам
                </button>
              </p>

              <p class="text-sm text-gray-500 mb-4">
                Банковский перевод может занять до трех рабочих дней <br>
                В назначении платежа укажите номер договора займа и ФИО Заемщика полностью <br>
                Для моментальной оплаты рекомендуем использовать Личный кабинет
              </p>
              <p class="font-medium">
                Реквизиты для перевода:
              </p>
              <div class="text-center bg-gray-50 rounded-lg p-4 flex flex-col md:flex-row items-center justify-center gap-6">
                <p>
                  ООО МКК <span class="font-bold">«Небус»</span><br>
                  БИК 044525974<br>
                  ИНН 9701204665<br>
                  р/с 40701810700000008370<br>
                  в АО «Т-Банк»
                </p>

                <p>
                  ООО МКК <span class="font-bold">«Небус»</span><br>
                  БИК 044525225<br>
                  ИНН 9701204665<br>
                  р/с 40701810538000110091<br>
                  в ПАО «Сбербанк»
                </p>

                <p>
                  ООО МКК <span class="font-bold">«Луна»</span><br>
                  БИК 044525974<br>
                  ИНН 9728109264 <br>
                  р/с 40701810300000009083 <br>
                  в АО «Т-Банк»
                </p>
              </div>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  </section>
</template>

<style scoped>
  @reference "tailwindcss";

:deep([data-state=active]) {
  transition: all 0.2s ease;
}

:deep(.tab-trigger) {
  @apply bg-gray-100 text-gray-700 hover:bg-gray-200;
}

:deep([data-state=active]) {
  box-shadow: 0 2px 8px -2px rgba(99, 102, 241, 0.15);
}

.tab-content {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
